import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "./injectCss";

const CSS = `
.js-card{
  background:var(--surface-card);border:1px solid var(--border-subtle);
  border-radius:var(--radius-lg);box-shadow:var(--shadow-sm);
}
.js-card--pad{padding:var(--space-6)}
.js-card--interactive{cursor:pointer;transition:box-shadow var(--dur-base) var(--ease-out),transform var(--dur-base) var(--ease-out),border-color var(--dur-base) var(--ease-out)}
.js-card--interactive:hover{box-shadow:var(--shadow-md);transform:translateY(-1px);border-color:var(--border-default)}
.js-card--flat{box-shadow:none}
.js-card__head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:var(--space-4)}
.js-card__title{font-size:var(--text-title);font-weight:var(--weight-bold);color:var(--text-strong);margin:0}
.js-card__sub{font-size:var(--text-sm);color:var(--text-muted);margin:2px 0 0}
`;

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  pad?: boolean;
  interactive?: boolean;
  flat?: boolean;
  title?: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
}

export function Card({
  pad = true,
  interactive = false,
  flat = false,
  title,
  subtitle,
  action,
  className = "",
  children,
  ...rest
}: CardProps) {
  injectCss("js-card-css", CSS);
  const cls = [
    "js-card",
    pad ? "js-card--pad" : "",
    interactive ? "js-card--interactive" : "",
    flat ? "js-card--flat" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} {...rest}>
      {(title || action) && (
        <div className="js-card__head">
          <div>
            {title && <h3 className="js-card__title">{title}</h3>}
            {subtitle && <p className="js-card__sub">{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
